<h1 mat-dialog-title>Bulk tag add confirmation</h1>
<mat-dialog-content>
    <p>Are you sure you want to add the tag: <b>{{ tags[0] }}</b> to the selected images?</p>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close>Close</button>
  <button mat-raised-button color="primary" [mat-dialog-close]="true">Confirm</button>
</mat-dialog-actions>

